import * as lscache from "lscache";

import {OTHER_PROPERTIES_ROOMS_FILTER} from "../../app/constants/storage_keys";

export const getLocalStoragePropertyRoomFilter = (): Record<string, string> => {
    const roomFilter = lscache.get(OTHER_PROPERTIES_ROOMS_FILTER);
    if (!roomFilter) {
        return {};
    }
    return roomFilter;
};

export const updateLocalStoragePropertyRoomFilter = (queryValues: Record<string, number | string>) => {
    lscache.set(OTHER_PROPERTIES_ROOMS_FILTER, queryValues);
};
import * as lscache from "lscache";

import {OTHER_PROPERTIES_ROOMS_FILTER} from "../../app/constants/storage_keys";

export const getLocalStoragePropertyRoomFilter = (): Record<string, string> => {
    const roomFilter = lscache.get(OTHER_PROPERTIES_ROOMS_FILTER);
    if (!roomFilter) {
        return {};
    }
    return roomFilter;
};

export const updateLocalStoragePropertyRoomFilter = (queryValues: Record<string, number | string>) => {
    lscache.set(OTHER_PROPERTIES_ROOMS_FILTER, queryValues);
};
